package br.gov.go.pge.permanenciaweb.site

import androidx.compose.runtime.staticCompositionLocalOf
import br.gov.go.pge.permanenciaweb.site.pages.DashboardState
import kotlinx.coroutines.CoroutineScope

/**
 * State that outlives a single page composition.
 *
 * The Kobweb router disposes the active page subtree on every path change. Anything kept with
 * `remember` inside `Index` would therefore be rebuilt when the user visits "Liberações" and
 * comes back. The dashboard state — snapshot, filters, sorts, pagination and the WebSocket
 * connection — lives here instead, above `router.renderActivePage`, so SPA navigation preserves
 * it.
 */
internal class AppState(val scope: CoroutineScope) {
    val dashboard = DashboardState()

    /** Guards the single long-lived WebSocket loop; survives page swaps. */
    var liveStarted = false
}

internal val LocalAppState = staticCompositionLocalOf<AppState> {
    error("AppState is only available inside AppEntry")
}
